import Model from "./Model";

export default class Locality extends Model {
  static type = "localities";

  name?: string;
  shortName?: string;
}
